import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IoMdClose } from 'react-icons/io';

import soundEs from 'assets/audio/conteo_es.mp3';
import soundEn from 'assets/audio/conteo_en.mp3';
import { useCountDown } from 'utils/hooks/useCountDown';
import { LANGUAGES, SESSION_STATES } from '../utils';

const CountDown = ({ sessionState, deadline, setDisplayAlert, changeSessionState }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation();
  const { seconds } = useCountDown({ deadline, decimals: false, endAction: changeSessionState });
  const timeLeft = sessionState === SESSION_STATES.COUNTDOWN && seconds > 5 ? 5 : seconds;
  const audio = language.indexOf(LANGUAGES.EN) !== -1 ? soundEn : soundEs;

  return (
    <section className="daily-exercises__countdown">
      <IoMdClose className="daily-exercises__countdown_closeicon" onClick={setDisplayAlert} />
      {sessionState === SESSION_STATES.BREAK ? (
        <button type="button" className="daily-exercises__countdown_skipbutton" onClick={changeSessionState}>
          {t('evieApp.countDown.skipButton')}
        </button>
      ) : null}
      <section className="countdown">
        <div className="countdown__wrapper">
          {sessionState === SESSION_STATES.COUNTDOWN ? (
            <audio autoPlay controls={false} src={audio}>
              <track kind="captions" />
              Your browser does not support the
              <code>audio</code> element.
            </audio>
          ) : null}
          <span>{timeLeft}</span>
        </div>
        {sessionState === SESSION_STATES.BREAK ? (
          <div className="countdown__content">
            <p className="countdown__content_label">{t('evieApp.countDown.breakLabel')}</p>
            <p className="countdown__content_label">{t('evieApp.countDown.nextLabel')}</p>
          </div>
        ) : null}
      </section>
    </section>
  );
};

CountDown.propTypes = {
  sessionState: PropTypes.string.isRequired,
  deadline: PropTypes.number.isRequired,
  setDisplayAlert: PropTypes.func.isRequired,
  changeSessionState: PropTypes.func.isRequired,
};

export default CountDown;
